<template>
  <div class="overview-summary">
    <!-- KPI 카드 섹션 -->
    <div class="kpi-section">
      <a-row :gutter="[16, 16]">
        <a-col :xs="24" :sm="12" :lg="6">
          <a-card class="kpi-card kpi-card-participants" :hoverable="true">
            <a-statistic
              title="총 참여자"
              :value="getAdjustedValue(kpiData.totalParticipants, 'totalParticipants')"
              suffix="명"
              :value-style="{ color: '#1890ff', fontSize: '28px', fontWeight: '700' }"
            >
              <template #prefix>
                <UserOutlined />
              </template>
            </a-statistic>
            <div class="kpi-subtitle">이벤트 전체 참여 고객</div>

            <!-- 세그먼트별 분석 -->
            <div v-if="summary && summary.participants && summary.participants.bySegment" class="participants-breakdown">
              <div class="breakdown-section">
                <div class="breakdown-title">👥 인증서 보유자</div>
                <div class="breakdown-value-row">
                  <span class="breakdown-value">{{ formatNumber(getAdjustedValue(summary.participants.bySegment.certificateHolder.total.value, 'participants_certificateHolder_total')) }}명</span>
                  <span class="breakdown-inline-desc" v-if="summary.participants.bySegment.certificateHolder.total.description && summary.participants.bySegment.certificateHolder.total.description.trim()">
                    ({{ summary.participants.bySegment.certificateHolder.total.description }})
                  </span>
                </div>
                <div class="breakdown-items">
                  <div class="breakdown-item">
                    <span class="item-label"><strong>• 신규:</strong></span>
                    <span class="item-value">{{ formatNumber(getAdjustedValue(summary.participants.bySegment.certificateHolder.newCertificate.value, 'participants_certificateHolder_new')) }}명</span>
                    <span class="item-inline-desc" v-if="summary.participants.bySegment.certificateHolder.newCertificate.description && summary.participants.bySegment.certificateHolder.newCertificate.description.trim()">
                      ({{ summary.participants.bySegment.certificateHolder.newCertificate.description }})
                    </span>
                  </div>
                  <div class="breakdown-item">
                    <span class="item-label"><strong>• 기존:</strong></span>
                    <span class="item-value">{{ formatNumber(getAdjustedValue(summary.participants.bySegment.certificateHolder.existingCertificate.value, 'participants_certificateHolder_existing')) }}명</span>
                    <span class="item-inline-desc" v-if="summary.participants.bySegment.certificateHolder.existingCertificate.description && summary.participants.bySegment.certificateHolder.existingCertificate.description.trim()">
                      ({{ summary.participants.bySegment.certificateHolder.existingCertificate.description }})
                    </span>
                  </div>
                </div>
              </div>

              <div class="breakdown-section">
                <div class="breakdown-title">🎯 인증서 미보유자</div>
                <div class="breakdown-value-row">
                  <span class="breakdown-value">{{ formatNumber(getAdjustedValue(summary.participants.bySegment.nonCertificate.value, 'participants_nonCertificate')) }}명</span>
                  <span class="breakdown-inline-desc" v-if="summary.participants.bySegment.nonCertificate.description && summary.participants.bySegment.nonCertificate.description.trim()">
                    ({{ summary.participants.bySegment.nonCertificate.description }})
                  </span>
                </div>
                <div class="breakdown-items">
                  <div class="breakdown-item">
                    <span class="item-label"><strong>• 써마지:</strong></span>
                    <span class="item-value">{{ formatNumber(getAdjustedValue(4733, 'participants_nonCertificate_thermage')) }}명</span>
                  </div>
                  <div class="breakdown-item">
                    <span class="item-label"><strong>• 공유참여:</strong></span>
                    <span class="item-value">{{ formatNumber(getAdjustedValue(summary.participants.bySegment.nonCertificate.value - 4733, 'participants_nonCertificate_shareParticipation')) }}명</span>
                  </div>
                </div>
              </div>
            </div>
          </a-card>
        </a-col>
        <a-col :xs="24" :sm="12" :lg="6">
          <a-card class="kpi-card kpi-card-reviews" :hoverable="true">
            <a-statistic
              title="후기 작성"
              :value="getAdjustedValue(kpiData.totalReviews, 'totalReviews')"
              suffix="건"
              :value-style="{ color: '#52c41a', fontSize: '28px', fontWeight: '700' }"
            >
              <template #prefix>
                <EditOutlined />
              </template>
            </a-statistic>
            <div class="kpi-subtitle">전체 후기 작성수</div>

            <!-- 세그먼트별 분석 -->
            <div v-if="summary && summary.reviews && summary.reviews.bySegment" class="reviews-breakdown">
              <div class="breakdown-section">
                <div class="breakdown-title">👥 인증서 보유자</div>
                <div class="breakdown-value-row">
                  <span class="breakdown-value">{{ formatNumber(getAdjustedValue(summary.reviews.bySegment.certificateHolder.total.value, 'reviews_certificateHolder_total')) }}건</span>
                  <span class="breakdown-inline-desc" v-if="summary.reviews.bySegment.certificateHolder.total.description && summary.reviews.bySegment.certificateHolder.total.description.trim()">
                    ({{ summary.reviews.bySegment.certificateHolder.total.description }})
                  </span>
                </div>
                <div class="breakdown-items">
                  <div class="breakdown-item">
                    <span class="item-label"><strong>• 신규:</strong></span>
                    <span class="item-value">{{ formatNumber(getAdjustedValue(summary.reviews.bySegment.certificateHolder.newCertificate.value, 'reviews_certificateHolder_new')) }}건</span>
                    <span class="item-inline-desc" v-if="summary.reviews.bySegment.certificateHolder.newCertificate.description && summary.reviews.bySegment.certificateHolder.newCertificate.description.trim()">
                      ({{ summary.reviews.bySegment.certificateHolder.newCertificate.description }})
                    </span>
                  </div>
                  <div class="breakdown-item">
                    <span class="item-label"><strong>• 기존:</strong></span>
                    <span class="item-value">{{ formatNumber(getAdjustedValue(summary.reviews.bySegment.certificateHolder.existingCertificate.value, 'reviews_certificateHolder_existing')) }}건</span>
                    <span class="item-inline-desc" v-if="summary.reviews.bySegment.certificateHolder.existingCertificate.description && summary.reviews.bySegment.certificateHolder.existingCertificate.description.trim()">
                      ({{ summary.reviews.bySegment.certificateHolder.existingCertificate.description }})
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </a-card>
        </a-col>
        <a-col :xs="24" :sm="12" :lg="6">
          <a-card class="kpi-card kpi-card-shares" :hoverable="true">
            <a-statistic
              title="공유"
              :value="getAdjustedValue(shareAnalysisData.totalShareCount, 'totalShareCount')"
              :value-style="{ color: '#faad14', fontSize: '28px', fontWeight: '700' }"
            >
              <template #prefix>
                <ShareAltOutlined />
              </template>
              <template #suffix>
                <span style="font-size: 18px; color: #faad14; font-weight: 600; margin-left: 4px;">회</span>
                <span style="font-size: 16px; color: #8c8c8c; font-weight: 500; margin-left: 8px;">
                  ({{ formatNumber(getAdjustedValue(shareAnalysisData.totalShareCustomers, 'totalShareCustomers')) }}명, {{ (getAdjustedValue(shareAnalysisData.totalShareCount, 'totalShareCount') / getAdjustedValue(shareAnalysisData.totalShareCustomers, 'totalShareCustomers')).toFixed(2) }}회/명)
                </span>
              </template>
            </a-statistic>
            <div class="kpi-subtitle">전체 공유수</div>

            <!-- 세그먼트별 분석 -->
            <div v-if="shareAnalysisData.hasCertificateHolder || shareAnalysisData.hasNonCertificate" class="shares-breakdown">
              <div v-if="shareAnalysisData.hasCertificateHolder" class="breakdown-section">
                <div class="breakdown-title">👥 인증서 보유자</div>
                <div class="breakdown-value-row">
                  <span class="breakdown-value">{{ formatNumber(getAdjustedValue(shareAnalysisData.certificateHolder.shareCount, 'shares_certificateHolder_total')) }}회</span>
                  <span class="breakdown-inline-desc">
                    {{ formatNumber(shareAnalysisData.certificateHolder.shareCustomers) }}명, {{ shareAnalysisData.certificateHolder.shareCustomers > 0 ? (getAdjustedValue(shareAnalysisData.certificateHolder.shareCount, 'shares_certificateHolder_total') / shareAnalysisData.certificateHolder.shareCustomers).toFixed(2) : '0.00' }}회/명
                  </span>
                </div>
                <!-- 세컨더리 세그먼트 -->
                <div v-if="shareAnalysisData.certificateHolder.secondary.length > 0" class="breakdown-items">
                  <div v-for="(seg, idx) in shareAnalysisData.certificateHolder.secondary" :key="idx" class="breakdown-item">
                    <span class="item-label"><strong>• {{ seg.label }}:</strong></span>
                    <span class="item-value">{{ formatNumber(getAdjustedValue(seg.shareCount, seg.label.includes('기존') ? 'shares_certificateHolder_existing' : 'shares_certificateHolder_new')) }}회</span>
                    <span class="item-inline-desc">
                      ({{ formatNumber(getAdjustedValue(seg.shareCustomers, seg.label.includes('기존') ? 'shares_certificateHolder_existing_customers' : 'shares_certificateHolder_new_customers')) }}명, {{ getAdjustedValue(seg.shareCustomers, seg.label.includes('기존') ? 'shares_certificateHolder_existing_customers' : 'shares_certificateHolder_new_customers') > 0 ? (getAdjustedValue(seg.shareCount, seg.label.includes('기존') ? 'shares_certificateHolder_existing' : 'shares_certificateHolder_new') / getAdjustedValue(seg.shareCustomers, seg.label.includes('기존') ? 'shares_certificateHolder_existing_customers' : 'shares_certificateHolder_new_customers')).toFixed(2) : '0.00' }}회/명)
                    </span>
                  </div>
                </div>
              </div>

              <div v-if="shareAnalysisData.hasNonCertificate" class="breakdown-section">
                <div class="breakdown-title">🎯 인증서 미보유자</div>
                <div class="breakdown-value-row">
                  <span class="breakdown-value">{{ formatNumber(getAdjustedValue(shareAnalysisData.nonCertificate.shareCount, 'shares_nonCertificate_total')) }}회</span>
                  <span class="breakdown-inline-desc">
                    {{ formatNumber(shareAnalysisData.nonCertificate.shareCustomers) }}명, {{ shareAnalysisData.nonCertificate.shareCustomers > 0 ? (getAdjustedValue(shareAnalysisData.nonCertificate.shareCount, 'shares_nonCertificate_total') / shareAnalysisData.nonCertificate.shareCustomers).toFixed(2) : '0.00' }}회/명
                  </span>
                </div>
                <!-- 세컨더리 세그먼트 -->
                <div v-if="shareAnalysisData.nonCertificate.secondary.length > 0" class="breakdown-items">
                  <div v-for="(seg, idx) in shareAnalysisData.nonCertificate.secondary" :key="idx" class="breakdown-item">
                    <span class="item-label"><strong>• {{ seg.label }}:</strong></span>
                    <span class="item-value">{{ formatNumber(getAdjustedValue(seg.shareCount, seg.label.includes('써마지') ? 'shares_nonCertificate_thermage' : 'shares_nonCertificate_eventParticipant')) }}회</span>
                    <span class="item-inline-desc">
                      ({{ formatNumber(getAdjustedValue(seg.shareCustomers, seg.label.includes('써마지') ? 'shares_nonCertificate_thermage_customers' : 'shares_nonCertificate_eventParticipant_customers')) }}명, {{ getAdjustedValue(seg.shareCustomers, seg.label.includes('써마지') ? 'shares_nonCertificate_thermage_customers' : 'shares_nonCertificate_eventParticipant_customers') > 0 ? (getAdjustedValue(seg.shareCount, seg.label.includes('써마지') ? 'shares_nonCertificate_thermage' : 'shares_nonCertificate_eventParticipant') / getAdjustedValue(seg.shareCustomers, seg.label.includes('써마지') ? 'shares_nonCertificate_thermage_customers' : 'shares_nonCertificate_eventParticipant_customers')).toFixed(2) : '0.00' }}회/명)
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </a-card>
        </a-col>
        <a-col :xs="24" :sm="12" :lg="6">
          <a-card class="kpi-card kpi-card-coupons" :hoverable="true">
            <a-statistic
              title="쿠폰 발급"
              :value="getAdjustedValue(couponAnalysisData.totalCouponIssuances, 'totalCoupons')"
              :value-style="{ color: '#722ed1', fontSize: '28px', fontWeight: '700' }"
            >
              <template #prefix>
                <GiftOutlined />
              </template>
              <template #suffix>
                <span style="font-size: 18px; color: '#722ed1'; font-weight: 600; margin-left: 4px;">회</span>
                <span style="font-size: 16px; color: #8c8c8c; font-weight: 500; margin-left: 8px;">
                  ({{ formatNumber(getAdjustedValue(couponAnalysisData.totalCouponRecipients, 'coupons_totalRecipients')) }}명, {{ getAdjustedValue(couponAnalysisData.totalCouponRecipients, 'coupons_totalRecipients') > 0 ? (getAdjustedValue(couponAnalysisData.totalCouponIssuances, 'totalCoupons') / getAdjustedValue(couponAnalysisData.totalCouponRecipients, 'coupons_totalRecipients')).toFixed(2) : '0.00' }}회/명)
                </span>
              </template>
            </a-statistic>
            <div class="kpi-subtitle">전체 쿠폰 발급량</div>

            <!-- 세그먼트별 분석 -->
            <div v-if="couponAnalysisData.hasCertificateHolder || couponAnalysisData.hasNonCertificate" class="coupons-breakdown">
              <div v-if="couponAnalysisData.hasCertificateHolder" class="breakdown-section">
                <div class="breakdown-title">👥 인증서 보유자</div>
                <div class="breakdown-value-row">
                  <span class="breakdown-value">{{ formatNumber(getAdjustedValue(couponAnalysisData.certificateHolder.couponIssuances, 'coupons_certificateHolder_total')) }}회</span>
                  <span class="breakdown-inline-desc">
                    {{ formatNumber(couponAnalysisData.certificateHolder.couponRecipients) }}명, {{ couponAnalysisData.certificateHolder.couponRecipients > 0 ? (getAdjustedValue(couponAnalysisData.certificateHolder.couponIssuances, 'coupons_certificateHolder_total') / couponAnalysisData.certificateHolder.couponRecipients).toFixed(2) : '0.00' }}회/명
                  </span>
                </div>
                <div class="breakdown-items">
                  <div class="breakdown-item">
                    <span class="item-label"><strong>• 신규:</strong></span>
                    <span class="item-value">{{ formatNumber(getAdjustedValue(couponAnalysisData.certificateHolder.secondary.find(s => s.label.includes('신규'))?.couponIssuances || 0, 'coupons_certificateHolder_new')) }}회</span>
                    <span class="item-inline-desc">
                      ({{ formatNumber(getAdjustedValue(couponAnalysisData.certificateHolder.secondary.find(s => s.label.includes('신규'))?.couponRecipients || 0, 'coupons_certificateHolder_new_recipients')) }}명, {{ (getAdjustedValue(couponAnalysisData.certificateHolder.secondary.find(s => s.label.includes('신규'))?.couponRecipients || 0, 'coupons_certificateHolder_new_recipients')) > 0 ? (getAdjustedValue(couponAnalysisData.certificateHolder.secondary.find(s => s.label.includes('신규'))?.couponIssuances || 0, 'coupons_certificateHolder_new') / getAdjustedValue(couponAnalysisData.certificateHolder.secondary.find(s => s.label.includes('신규'))?.couponRecipients || 0, 'coupons_certificateHolder_new_recipients')).toFixed(2) : '0.00' }}회/명)
                    </span>
                  </div>
                  <div class="breakdown-item">
                    <span class="item-label"><strong>• 기존:</strong></span>
                    <span class="item-value">{{ formatNumber(getAdjustedValue(couponAnalysisData.certificateHolder.secondary.find(s => s.label.includes('기존'))?.couponIssuances || 0, 'coupons_certificateHolder_existing')) }}회</span>
                    <span class="item-inline-desc">
                      ({{ formatNumber(getAdjustedValue(couponAnalysisData.certificateHolder.secondary.find(s => s.label.includes('기존'))?.couponRecipients || 0, 'coupons_certificateHolder_existing_recipients')) }}명, {{ (getAdjustedValue(couponAnalysisData.certificateHolder.secondary.find(s => s.label.includes('기존'))?.couponRecipients || 0, 'coupons_certificateHolder_existing_recipients')) > 0 ? (getAdjustedValue(couponAnalysisData.certificateHolder.secondary.find(s => s.label.includes('기존'))?.couponIssuances || 0, 'coupons_certificateHolder_existing') / getAdjustedValue(couponAnalysisData.certificateHolder.secondary.find(s => s.label.includes('기존'))?.couponRecipients || 0, 'coupons_certificateHolder_existing_recipients')).toFixed(2) : '0.00' }}회/명)
                    </span>
                  </div>
                </div>
              </div>

              <div v-if="couponAnalysisData.hasNonCertificate" class="breakdown-section">
                <div class="breakdown-title">🎯 인증서 미보유자</div>
                <div class="breakdown-value-row">
                  <span class="breakdown-value">{{ formatNumber(getAdjustedValue(couponAnalysisData.nonCertificate.couponIssuances, 'coupons_nonCertificate_total')) }}회</span>
                  <span class="breakdown-inline-desc">
                    {{ formatNumber(couponAnalysisData.nonCertificate.couponRecipients) }}명, {{ couponAnalysisData.nonCertificate.couponRecipients > 0 ? (getAdjustedValue(couponAnalysisData.nonCertificate.couponIssuances, 'coupons_nonCertificate_total') / couponAnalysisData.nonCertificate.couponRecipients).toFixed(2) : '0.00' }}회/명
                  </span>
                </div>
                <!-- 세컨더리 세그먼트 -->
                <div v-if="couponAnalysisData.nonCertificate.secondary.length > 0" class="breakdown-items">
                  <div v-for="(seg, idx) in couponAnalysisData.nonCertificate.secondary" :key="idx" class="breakdown-item">
                    <span class="item-label"><strong>• {{ seg.label }}:</strong></span>
                    <span class="item-value">{{ formatNumber(getAdjustedValue(seg.couponIssuances, seg.label.includes('써마지') ? 'coupons_nonCertificate_thermage' : 'coupons_nonCertificate_eventParticipant')) }}회</span>
                    <span class="item-inline-desc">
                      ({{ formatNumber(getAdjustedValue(seg.couponRecipients, seg.label.includes('써마지') ? 'coupons_nonCertificate_thermage_recipients' : 'coupons_nonCertificate_eventParticipant_recipients')) }}명, {{ getAdjustedValue(seg.couponRecipients, seg.label.includes('써마지') ? 'coupons_nonCertificate_thermage_recipients' : 'coupons_nonCertificate_eventParticipant_recipients') > 0 ? (getAdjustedValue(seg.couponIssuances, seg.label.includes('써마지') ? 'coupons_nonCertificate_thermage' : 'coupons_nonCertificate_eventParticipant') / getAdjustedValue(seg.couponRecipients, seg.label.includes('써마지') ? 'coupons_nonCertificate_thermage_recipients' : 'coupons_nonCertificate_eventParticipant_recipients')).toFixed(2) : '0.00' }}회/명)
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </a-card>
        </a-col>
      </a-row>
    </div>

    <!-- 병원 예약 섹션 (별도 행) -->
    <div class="reservation-section">
      <h3 class="section-header">📅 병원 예약 현황</h3>
      <a-row :gutter="[16, 16]">
        <!-- 서머리 카드 -->
        <a-col :xs="24" :sm="12" :lg="8">
          <a-card class="reservation-card summary-card" :hoverable="true">
            <div class="card-title">📊 예약 서머리</div>
            <div class="summary-stats">
              <div class="stat-item">
                <div class="stat-label">전체 예약 건수</div>
                <div class="stat-value total-count">{{ formatNumber(getAdjustedValue(reservationSummary.totalReservations, 'reservation_totalReservations')) }}</div>
              </div>
              <div class="stat-divider"></div>
              <div class="stat-item">
                <div class="stat-label">유니크 사용자 수</div>
                <div class="stat-value unique-count">{{ formatNumber(getAdjustedValue(reservationSummary.uniquePatients, 'reservation_uniquePatients')) }}</div>
              </div>
              <div class="stat-divider"></div>
              <div class="stat-item">
                <div class="stat-label">예약 병원 수</div>
                <div class="stat-value hospital-count">{{ formatNumber(getAdjustedValue(reservationSummary.totalHospitals, 'reservation_totalHospitals')) }}</div>
              </div>
            </div>
          </a-card>
        </a-col>

        <!-- 일자별 예약 카드 -->
        <a-col :xs="24" :sm="12" :lg="8">
          <a-card class="reservation-card daily-card" :hoverable="true">
            <div class="card-title">📆 일자별 예약</div>
            <div class="daily-list">
              <div v-for="(item, index) in dailyReservations" :key="index" class="daily-item">
                <div class="daily-date">{{ formatDate(item.date) }}</div>
                <div class="daily-stats">
                  <span class="daily-count">{{ item.count }}건</span>
                  <span class="daily-users">({{ item.uniqueUsers }}명)</span>
                </div>
              </div>
              <div v-if="dailyReservations.length === 0" class="empty-message">
                예약 데이터가 없습니다.
              </div>
            </div>
          </a-card>
        </a-col>

        <!-- 병원별 예약 카드 -->
        <a-col :xs="24" :sm="12" :lg="8">
          <a-card class="reservation-card hospital-card" :hoverable="true">
            <div class="card-title">🏥 병원별 예약</div>
            <div class="hospital-list">
              <div v-for="(item, index) in hospitalReservations" :key="index" class="hospital-item">
                <div class="hospital-name">{{ item.hospitalName }}</div>
                <div class="hospital-count">{{ item.count }}건</div>
              </div>
              <div v-if="hospitalReservations.length === 0" class="empty-message">
                예약 데이터가 없습니다.
              </div>
            </div>
          </a-card>
        </a-col>
      </a-row>
    </div>

    <!-- 리뷰 현황 섹션 -->
    <div class="review-section">
      <h3 class="section-header">✍️ 리뷰 현황</h3>
      <a-row :gutter="[16, 16]">
        <!-- 서머리 카드 -->
        <a-col :xs="24" :sm="12" :lg="8">
          <a-card class="review-card summary-card" :hoverable="true">
            <div class="card-title">📊 리뷰 서머리</div>
            <div class="summary-stats">
              <div class="stat-item">
                <div class="stat-label">전체 리뷰 수</div>
                <div class="stat-value total-count">{{ formatNumber(getAdjustedValue(reviewSummary.totalReviews, 'reviewSummary_totalReviews')) }}</div>
              </div>
              <div class="stat-divider"></div>
              <div class="stat-item">
                <div class="stat-label">평균 점수</div>
                <div class="stat-value average-score">{{ reviewSummary.averageScore.toFixed(2) }}</div>
              </div>
              <div class="stat-divider"></div>
              <div class="stat-item">
                <div class="stat-label">긍정 리뷰 비율(4점이상)</div>
                <div class="stat-value positive-rate">{{ formatPercentage(reviewSummary.positiveReviewRate * 100) }}</div>
              </div>
            </div>
          </a-card>
        </a-col>

        <!-- 카테고리별 리뷰 카드 -->
        <a-col :xs="24" :sm="12" :lg="8">
          <a-card class="review-card category-card" :hoverable="true">
            <div class="card-title">📂 카테고리별 리뷰</div>
            <div class="category-list">
              <div v-for="(item, index) in reviewsByCategory" :key="index" class="category-item">
                <div class="category-info">
                  <div class="category-name">{{ item.categoryName }}</div>
                  <div class="category-percentage">{{ formatPercentage(item.percentage) }}</div>
                </div>
                <div class="category-stats">
                  <span class="category-count">{{ formatNumber(item.reviewCount) }}건</span>
                  <span class="category-score">⭐ {{ item.averageScore.toFixed(2) }}</span>
                </div>
              </div>
              <div v-if="reviewsByCategory.length === 0" class="empty-message">
                리뷰 데이터가 없습니다.
              </div>
            </div>
          </a-card>
        </a-col>

        <!-- 병원별 리뷰 카드 -->
        <a-col :xs="24" :sm="12" :lg="8">
          <a-card class="review-card hospital-card" :hoverable="true">
            <div class="card-title">🏥 병원별 리뷰 Top 10</div>
            <div class="hospital-review-list">
              <div v-for="(item, index) in reviewsByHospital" :key="index" class="hospital-review-item">
                <div class="hospital-review-info">
                  <div class="hospital-review-rank">{{ index + 1 }}</div>
                  <div class="hospital-review-name">{{ item.companyName }}</div>
                </div>
                <div class="hospital-review-stats">
                  <span class="hospital-review-count">{{ formatNumber(item.reviewCount) }}건</span>
                  <span class="hospital-review-score">⭐ {{ item.averageScore.toFixed(2) }}</span>
                </div>
              </div>
              <div v-if="reviewsByHospital.length === 0" class="empty-message">
                리뷰 데이터가 없습니다.
              </div>
            </div>
          </a-card>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import { ref, reactive, computed, watch, onMounted, onBeforeUnmount, nextTick, getCurrentInstance } from 'vue';
import { Card, Row, Col, Statistic, Progress, Table, Tabs } from 'ant-design-vue';
import { useStore } from 'vuex';
import {
  UserOutlined,
  EditOutlined,
  CalendarOutlined,
  ShareAltOutlined,
  GiftOutlined,
  DownOutlined,
} from '@ant-design/icons-vue';
import { Chart, registerables } from 'chart.js';
import { formatNumber, formatPercentage, messageTypeLabels, calculateWeightedAverage } from '../utils';
import createReportApi from '../api';

Chart.register(...registerables);

export default {
  name: 'OverviewSummary',
  components: {
    ACard: Card,
    ARow: Row,
    ACol: Col,
    AStatistic: Statistic,
    AProgress: Progress,
    ATable: Table,
    ATabs: Tabs,
    ATabPane: Tabs.TabPane,
    UserOutlined,
    EditOutlined,
    CalendarOutlined,
    ShareAltOutlined,
    GiftOutlined,
    DownOutlined,
  },
  props: {
    dailyMessageConversions: {
      type: Array,
      default: () => []
    },
    dailyConversions: {
      type: Array,
      default: () => []
    },
    cumulativeSummaries: {
      type: Array,
      default: () => []
    },
    overallSummary: {
      type: Object,
      default: () => null
    },
    summary: {
      type: Object,
      default: () => null
    },
    reportId: {
      type: String,
      default: null
    }
  },
  setup(props) {
    const { proxy } = getCurrentInstance();
    const store = useStore();
    const api = createReportApi(proxy.$apiInstance, store);

    const trendTab = ref('certificate');
    const trendChartCertificate = ref(null);
    const trendChartFriend = ref(null);
    let chartInstances = {
      certificate: null,
      friend: null
    };

    // 보정치 저장 (API에서 로드)
    const adjustments = reactive({});

    // 보정치가 적용된 값 반환 (최종값만 표시, 계산과정 없음)
    const getAdjustedValue = (originalValue, fieldKey) => {
      const adjustment = adjustments[fieldKey];
      if (adjustment !== undefined && adjustment !== null && adjustment !== 0) {
        return originalValue + adjustment;
      }
      return originalValue;
    };

    // 보정치 로드
    const loadAdjustments = () => {
      console.log('🔍 [loadAdjustments] 호출됨, reportId:', props.reportId);
      if (!props.reportId) {
        console.warn('⚠️ [loadAdjustments] reportId가 없습니다');
        return;
      }

      api.getAdjustments(
        { reportId: props.reportId },
        (response) => {
          console.log('🔍 [loadAdjustments] API 응답 전체:', response);
          console.log('🔍 [loadAdjustments] response.data:', response?.data);
          console.log('🔍 [loadAdjustments] response.adjustments:', response?.adjustments);

          const adjustmentsData = response?.data || response?.adjustments || {};
          console.log('🔍 [loadAdjustments] adjustmentsData:', adjustmentsData);
          console.log('🔍 [loadAdjustments] adjustmentsData keys:', Object.keys(adjustmentsData));

          if (adjustmentsData && Object.keys(adjustmentsData).length > 0) {
            Object.entries(adjustmentsData).forEach(([key, data]) => {
              console.log(`🔍 [loadAdjustments] 보정치 저장: ${key} = ${data.value || 0}`);
              adjustments[key] = data.value || 0;
            });
            console.log('🔍 [loadAdjustments] 최종 adjustments 객체:', { ...adjustments });
          } else {
            console.warn('⚠️ [loadAdjustments] adjustmentsData가 비어있습니다');
          }
        },
        (error) => {
          console.error('❌ [loadAdjustments] API 오류:', error);
        }
      );
    };

    // KPI 데이터 계산 (summary 우선 사용)
    const kpiData = computed(() => {
      return {
        // summary.participants.total을 사용 (전체 이벤트 참여자 수)
        totalParticipants: (props.summary && props.summary.participants && props.summary.participants.total)
          ? props.summary.participants.total
          : 0,
        // summary.reviews.total을 사용 (전체 후기 작성수)
        totalReviews: (props.summary && props.summary.reviews && props.summary.reviews.total)
          ? props.summary.reviews.total
          : 0,
        // summary.shares.total을 사용 (전체 공유수)
        totalShares: (props.summary && props.summary.shares && props.summary.shares.total)
          ? props.summary.shares.total
          : 0,
        // summary.coupons.total을 사용 (전체 쿠폰 발급량)
        totalCoupons: (props.summary && props.summary.coupons && props.summary.coupons.total)
          ? props.summary.coupons.total
          : 0,
      };
    });

    // 전체 퍼널 단계 계산
    const funnelSteps = computed(() => {
      const totalSent = props.cumulativeSummaries.reduce((sum, item) => sum + (item.totalSent || 0), 0);
      const totalClicks = props.cumulativeSummaries.reduce((sum, item) => sum + (item.totalClicks || 0), 0);
      const totalParticipants = kpiData.value.totalParticipants;
      const totalConversions = kpiData.value.totalReviews + kpiData.value.totalReservations;

      const maxValue = totalSent || 1;

      return [
        {
          label: '메시지 발송',
          value: totalSent,
          width: 100,
          color: '#1890ff',
          rate: null
        },
        {
          label: '클릭',
          value: totalClicks,
          width: (totalClicks / maxValue) * 100,
          color: '#52c41a',
          rate: totalSent > 0 ? (totalClicks / totalSent) * 100 : 0
        },
        {
          label: '참여',
          value: totalParticipants,
          width: (totalParticipants / maxValue) * 100,
          color: '#faad14',
          rate: totalClicks > 0 ? (totalParticipants / totalClicks) * 100 : 0
        },
        {
          label: '전환 (후기 + 예약)',
          value: totalConversions,
          width: (totalConversions / maxValue) * 100,
          color: '#f5222d',
          rate: totalParticipants > 0 ? (totalConversions / totalParticipants) * 100 : 0
        }
      ];
    });

    // 인증서 보유자 세그먼트 요약
    const certificateSegment = computed(() => {
      const data = props.cumulativeSummaries.filter(
        item => item.messageType === 'certificate' || item.messageType === 'review'
      );
      const sent = data.reduce((sum, item) => sum + (item.totalSent || 0), 0);
      const clicks = data.reduce((sum, item) => sum + (item.totalClicks || 0), 0);
      const reviews = data.reduce((sum, item) => sum + (item.totalReviewSubmissions || 0), 0);

      return {
        sent,
        clickRate: sent > 0 ? (clicks / sent) * 100 : 0,
        reviews,
        reviewRate: sent > 0 ? (reviews / sent) * 100 : 0,
      };
    });

    // 신규 고객 세그먼트 요약
    const nonCertificateSegment = computed(() => {
      const data = props.cumulativeSummaries.filter(item => item.messageType === 'friend');
      const quizParticipants = data.reduce((sum, item) => sum + (item.totalQuizParticipants || 0), 0);
      const reservations = data.reduce((sum, item) => sum + (item.totalReservations || 0), 0);
      const totalParticipants = kpiData.value.totalParticipants;

      return {
        quizParticipants,
        quizRate: totalParticipants > 0 ? (quizParticipants / totalParticipants) * 100 : 0,
        reservations,
        reservationRate: quizParticipants > 0 ? (reservations / quizParticipants) * 100 : 0,
      };
    });

    // 누적요약 테이블 컬럼
    const cumulativeColumns = [
      { title: '구분', dataIndex: 'category', key: 'category', width: 150, fixed: 'left' },
      { title: '발송건수', dataIndex: 'totalSent', key: 'totalSent', width: 120, align: 'right' },
      { title: '클릭률', dataIndex: 'clickRate', key: 'clickRate', width: 100, align: 'right' },
      { title: '이벤트참여자수', dataIndex: 'totalParticipants', key: 'totalParticipants', width: 140, align: 'right' },
      { title: '후기페이지유입수', dataIndex: 'totalReviewPageLandings', key: 'totalReviewPageLandings', width: 140, align: 'right' },
      { title: '만족도입력수', dataIndex: 'totalSatisfactionInputs', key: 'totalSatisfactionInputs', width: 120, align: 'right' },
      { title: '후기작성률', dataIndex: 'reviewSubmissionRate', key: 'reviewSubmissionRate', width: 120, align: 'right' },
      { title: '병원선택수', dataIndex: 'totalHospitalSelections', key: 'totalHospitalSelections', width: 110, align: 'right' },
      { title: '고객정보입력수', dataIndex: 'totalCustomerInfoInputs', key: 'totalCustomerInfoInputs', width: 130, align: 'right' },
      { title: '병원예약률', dataIndex: 'reservationRate', key: 'reservationRate', width: 120, align: 'right' },
      { title: '공유율', dataIndex: 'shareRate', key: 'shareRate', width: 100, align: 'right' },
      { title: '퀴즈참여율', dataIndex: 'quizParticipationRate', key: 'quizParticipationRate', width: 120, align: 'right' },
      { title: '퀴즈참여자유도수', dataIndex: 'totalReferredQuizParticipants', key: 'totalReferredQuizParticipants', width: 140, align: 'right' },
      { title: '쿠폰발급수', dataIndex: 'totalCoupons', key: 'totalCoupons', width: 110, align: 'right' },
      { title: '쿠폰발급률', dataIndex: 'couponIssuanceRate', key: 'couponIssuanceRate', width: 110, align: 'right' },
    ];

    // 누적요약 테이블 데이터 계산
    const cumulativeTableData = computed(() => {
      if (!props.cumulativeSummaries || props.cumulativeSummaries.length === 0) return [];

      const items = props.cumulativeSummaries.map(item => ({
        ...item,
        category: messageTypeLabels[item.messageType] || item.messageType,
        isTotal: false
      }));

      // 전체합계 계산
      const totalSent = items.reduce((sum, item) => sum + (item.totalSent || 0), 0);
      const totalParticipants = items.reduce((sum, item) => sum + (item.totalParticipants || 0), 0);
      const totalReviewPageLandings = items.reduce((sum, item) => sum + (item.totalReviewPageLandings || 0), 0);
      const totalSatisfactionInputs = items.reduce((sum, item) => sum + (item.totalSatisfactionInputs || 0), 0);
      const totalHospitalSelections = items.reduce((sum, item) => sum + (item.totalHospitalSelections || 0), 0);
      const totalCustomerInfoInputs = items.reduce((sum, item) => sum + (item.totalCustomerInfoInputs || 0), 0);
      const totalReferredQuizParticipants = items.reduce((sum, item) => sum + (item.totalReferredQuizParticipants || 0), 0);
      const totalCouponIssuances = items.reduce((sum, item) => sum + (item.totalCouponIssuances || 0), 0);

      items.push({
        category: '전체합계',
        totalSent,
        clickRate: calculateWeightedAverage(props.cumulativeSummaries, 'clickRate', 'totalSent'),
        totalParticipants,
        totalReviewPageLandings,
        totalSatisfactionInputs,
        totalHospitalSelections,
        totalCustomerInfoInputs,
        totalReferredQuizParticipants,
        totalCouponIssuances,
        reviewSubmissionRate: calculateWeightedAverage(props.cumulativeSummaries, 'reviewSubmissionRate', 'totalSent'),
        shareRate: calculateWeightedAverage(props.cumulativeSummaries, 'shareRate', 'totalSent'),
        quizParticipationRate: calculateWeightedAverage(props.cumulativeSummaries, 'quizParticipationRate', 'totalSent'),
        reservationRate: calculateWeightedAverage(props.cumulativeSummaries, 'reservationRate', 'totalSent'),
        couponIssuanceRate: calculateWeightedAverage(props.cumulativeSummaries, 'couponIssuanceRate', 'totalSent'),
        isTotal: true
      });

      return items;
    });

    const getCumulativeRowClassName = (record) => {
      return record.isTotal ? 'total-row' : '';
    };

    // 병원 예약 서머리 계산
    const reservationSummary = computed(() => {
      console.log('🔍 [reservationSummary] props.summary:', props.summary);
      console.log('🔍 [reservationSummary] hospitalReservationStats:', props.summary?.hospitalReservationStats);
      console.log('🔍 [reservationSummary] summary:', props.summary?.hospitalReservationStats?.summary);

      if (!props.summary || !props.summary.hospitalReservationStats || !props.summary.hospitalReservationStats.summary) {
        console.warn('⚠️ [reservationSummary] 데이터가 없습니다');
        return {
          totalReservations: 0,
          uniquePatients: 0,
          totalHospitals: 0,
          totalItems: 0
        };
      }
      return props.summary.hospitalReservationStats.summary;
    });

    // 일자별 예약 목록
    const dailyReservations = computed(() => {
      console.log('🔍 [dailyReservations] dailyReservations:', props.summary?.hospitalReservationStats?.dailyReservations);

      if (!props.summary || !props.summary.hospitalReservationStats || !props.summary.hospitalReservationStats.dailyReservations) {
        console.warn('⚠️ [dailyReservations] 데이터가 없습니다');
        return [];
      }
      return props.summary.hospitalReservationStats.dailyReservations;
    });

    // 병원별 예약 목록
    const hospitalReservations = computed(() => {
      console.log('🔍 [hospitalReservations] byHospital:', props.summary?.hospitalReservationStats?.byHospital);

      if (!props.summary || !props.summary.hospitalReservationStats || !props.summary.hospitalReservationStats.byHospital) {
        console.warn('⚠️ [hospitalReservations] 데이터가 없습니다');
        return [];
      }
      return props.summary.hospitalReservationStats.byHospital;
    });

    // 리뷰 서머리 계산 (신규 reviewStats 및 과거 reviewAnalysisStats 형식 모두 지원)
    const reviewSummary = computed(() => {
      console.log('🔍 [reviewSummary] props.summary:', props.summary);
      console.log('🔍 [reviewSummary] reviewStats:', props.summary?.reviewStats);
      console.log('🔍 [reviewSummary] reviewAnalysisStats:', props.summary?.reviewAnalysisStats);

      const defaultValue = {
        totalReviews: 0,
        averageScore: 0,
        positiveReviewRate: 0,
        negativeReviewRate: 0,
        scoreDistribution: {
          score1: 0,
          score2: 0,
          score3: 0,
          score4: 0,
          score5: 0
        }
      };

      if (!props.summary) {
        console.warn('⚠️ [reviewSummary] summary 데이터가 없습니다');
        return defaultValue;
      }

      // 신규 형식 (reviewStats) 우선 확인
      if (props.summary.reviewStats?.summary) {
        console.log('✅ [reviewSummary] 신규 형식(reviewStats) 사용');
        return props.summary.reviewStats.summary;
      }

      // 과거 형식 (reviewAnalysisStats) 폴백
      if (props.summary.reviewAnalysisStats?.summary) {
        console.log('✅ [reviewSummary] 과거 형식(reviewAnalysisStats) 사용');
        return props.summary.reviewAnalysisStats.summary;
      }

      console.warn('⚠️ [reviewSummary] 데이터가 없습니다');
      return defaultValue;
    });

    // 카테고리별 리뷰 목록 (병합 처리) - 신규 reviewStats 및 과거 reviewAnalysisStats 형식 모두 지원
    const reviewsByCategory = computed(() => {
      console.log('🔍 [reviewsByCategory] reviewStats.byCategory:', props.summary?.reviewStats?.byCategory);
      console.log('🔍 [reviewsByCategory] reviewAnalysisStats.byCategory:', props.summary?.reviewAnalysisStats?.byCategory);

      if (!props.summary) {
        console.warn('⚠️ [reviewsByCategory] summary 데이터가 없습니다');
        return [];
      }

      // 신규 형식 (reviewStats) 우선 확인
      let rawCategories = null;
      if (props.summary.reviewStats?.byCategory) {
        console.log('✅ [reviewsByCategory] 신규 형식(reviewStats) 사용');
        rawCategories = props.summary.reviewStats.byCategory;
      } else if (props.summary.reviewAnalysisStats?.byCategory) {
        console.log('✅ [reviewsByCategory] 과거 형식(reviewAnalysisStats) 사용');
        rawCategories = props.summary.reviewAnalysisStats.byCategory;
      }

      if (!rawCategories) {
        console.warn('⚠️ [reviewsByCategory] 데이터가 없습니다');
        return [];
      }

      const categories = [...rawCategories];
      const mergedCategories = [];
      const processedIndices = new Set();

      // 1. "스마일", "스마일라식", "기타" 병합
      const smileIndices = [];
      categories.forEach((cat, idx) => {
        if (cat.categoryName === '스마일' || cat.categoryName === '스마일라식' || cat.categoryName === '기타') {
          smileIndices.push(idx);
        }
      });

      if (smileIndices.length > 0) {
        let totalReviews = 0;
        let weightedScore = 0;
        let totalPercentage = 0;

        smileIndices.forEach(idx => {
          const cat = categories[idx];
          totalReviews += cat.reviewCount;
          weightedScore += cat.reviewCount * cat.averageScore;
          totalPercentage += cat.percentage;
          processedIndices.add(idx);
        });

        mergedCategories.push({
          categoryName: '스마일',
          reviewCount: totalReviews,
          averageScore: totalReviews > 0 ? weightedScore / totalReviews : 0,
          percentage: totalPercentage
        });
      }

      // 2. "스마일 프로", "스마일프로" 병합
      const smileProIndices = [];
      categories.forEach((cat, idx) => {
        if (cat.categoryName === '스마일 프로' || cat.categoryName === '스마일프로') {
          smileProIndices.push(idx);
        }
      });

      if (smileProIndices.length > 0) {
        let totalReviews = 0;
        let weightedScore = 0;
        let totalPercentage = 0;

        smileProIndices.forEach(idx => {
          const cat = categories[idx];
          totalReviews += cat.reviewCount;
          weightedScore += cat.reviewCount * cat.averageScore;
          totalPercentage += cat.percentage;
          processedIndices.add(idx);
        });

        mergedCategories.push({
          categoryName: '스마일 프로',
          reviewCount: totalReviews,
          averageScore: totalReviews > 0 ? weightedScore / totalReviews : 0,
          percentage: totalPercentage
        });
      }

      // 3. 나머지 카테고리 추가
      categories.forEach((cat, idx) => {
        if (!processedIndices.has(idx)) {
          mergedCategories.push(cat);
        }
      });

      // 4. 리뷰 수 기준 정렬 후 상위 8개 반환
      return mergedCategories
        .sort((a, b) => b.reviewCount - a.reviewCount)
        .slice(0, 8);
    });

    // 병원별 리뷰 목록 (리뷰 수 기준 Top 10) - 신규 reviewStats 및 과거 reviewAnalysisStats 형식 모두 지원
    const reviewsByHospital = computed(() => {
      console.log('🔍 [reviewsByHospital] reviewStats.byHospital:', props.summary?.reviewStats?.byHospital);
      console.log('🔍 [reviewsByHospital] reviewAnalysisStats.byHospital.topByCount:', props.summary?.reviewAnalysisStats?.byHospital?.topByCount);

      if (!props.summary) {
        console.warn('⚠️ [reviewsByHospital] summary 데이터가 없습니다');
        return [];
      }

      // 신규 형식 (reviewStats) - byHospital이 배열
      if (props.summary.reviewStats?.byHospital && Array.isArray(props.summary.reviewStats.byHospital)) {
        console.log('✅ [reviewsByHospital] 신규 형식(reviewStats.byHospital) 사용');
        return props.summary.reviewStats.byHospital;
      }

      // 과거 형식 (reviewAnalysisStats) - byHospital.topByCount가 중첩 구조
      if (props.summary.reviewAnalysisStats?.byHospital?.topByCount) {
        console.log('✅ [reviewsByHospital] 과거 형식(reviewAnalysisStats.byHospital.topByCount) 사용');
        return props.summary.reviewAnalysisStats.byHospital.topByCount;
      }

      console.warn('⚠️ [reviewsByHospital] 데이터가 없습니다');
      return [];
    });

    // 세컨더리 세그먼트 라벨 맵핑
    const secondarySegmentLabels = {
      EXISTING_CERTIFICATE: '기존 인증서',
      NEW_CERTIFICATE: '신규 인증서',
      EVENT_PARTICIPANT: '이벤트 참여자',
      NON_PARTICIPANT: '미참여자',
      QUIZ_PARTICIPANT: '퀴즈 참여자',
      REVIEW_WRITER: '후기 작성자',
      SHARER: '공유자',
      THERMAGE: '써마지',
      THERMAGE_TO_ATTENDEE: '써마지 참석자',
    };

    // 세컨더리 세그먼트 라벨 추출 (콤마로 구분된 경우 첫 번째 유효한 라벨 사용)
    const getSecondarySegmentLabel = (segmentString) => {
      if (!segmentString) return segmentString;

      // 콤마로 구분된 경우 각 부분을 순회하며 매핑된 라벨 찾기
      const segments = segmentString.split(',');
      for (const seg of segments) {
        const trimmed = seg.trim();
        if (secondarySegmentLabels[trimmed]) {
          return secondarySegmentLabels[trimmed];
        }
      }

      // 매핑된 라벨이 없으면 원본 반환
      return segmentString;
    };

    // 공유 분석 데이터 계산
    const shareAnalysisData = computed(() => {
      const analysis = props.summary?.shareSegmentAnalysis;
      console.log('🔍 [shareAnalysisData] analysis:', analysis);

      if (!analysis) {
        return {
          totalShareCount: 0,
          totalShareCustomers: 0,
          overallShareRate: 0,
          hasCertificateHolder: false,
          hasNonCertificate: false,
          certificateHolder: { shareCount: 0, shareCustomers: 0, shareRate: 0, secondary: [] },
          nonCertificate: { shareCount: 0, shareCustomers: 0, shareRate: 0, secondary: [] }
        };
      }

      const processSegment = (primarySegmentData) => {
        if (!primarySegmentData) return { shareCount: 0, shareCustomers: 0, shareRate: 0, secondary: [] };

        console.log('🔍 [processSegment] primarySegmentData:', primarySegmentData);

        // total 데이터 추출
        const total = primarySegmentData.total || {};

        // bySecondarySegment는 배열
        const secondary = [];
        if (primarySegmentData.bySecondarySegment && Array.isArray(primarySegmentData.bySecondarySegment)) {
          primarySegmentData.bySecondarySegment.forEach(item => {
            if (item.shareCount > 0) { // 공유 건수가 0보다 큰 경우만 표시
              secondary.push({
                label: getSecondarySegmentLabel(item.secondarySegment),
                shareCount: item.shareCount || 0,
                shareCustomers: item.shareCustomers || 0,
                shareRate: (item.shareRate || 0) * 100
              });
            }
          });
        }

        console.log('🔍 [processSegment] secondary:', secondary);

        return {
          shareCount: total.shareCount || 0,
          shareCustomers: total.shareCustomers || 0,
          shareRate: (total.shareRate || 0) * 100,
          secondary
        };
      };

      const certificateHolder = processSegment(analysis.byPrimarySegment?.CERTIFICATE_HOLDER);
      const nonCertificate = processSegment(analysis.byPrimarySegment?.NON_CERTIFICATE);

      console.log('🔍 [shareAnalysisData] certificateHolder:', certificateHolder);
      console.log('🔍 [shareAnalysisData] nonCertificate:', nonCertificate);

      return {
        totalShareCount: analysis.overall?.shareCount || 0,
        totalShareCustomers: analysis.overall?.shareCustomers || 0,
        overallShareRate: (analysis.overall?.shareRate || 0) * 100,
        hasCertificateHolder: certificateHolder.shareCount > 0,
        hasNonCertificate: nonCertificate.shareCount > 0,
        certificateHolder,
        nonCertificate
      };
    });

    // 쿠폰 분석 데이터 계산 (데이터 소스 우선순위 적용)
    const couponAnalysisData = computed(() => {
      // 1순위: EventReport에 저장된 couponStats (운영에서 저장한 보정된 데이터)
      if (props.summary?.couponStats?.summary) {
        const savedSummary = props.summary.couponStats.summary;
        const bySegment = props.summary.couponStats.bySegment || {};
        const certHolder = bySegment.certificateHolder || { couponIssuances: 0, couponRecipients: 0, secondary: [] };
        const nonCert = bySegment.nonCertificate || { couponIssuances: 0, couponRecipients: 0, secondary: [] };

        console.log('🔍 [couponAnalysisData] couponStats 데이터 사용:', savedSummary);

        return {
          totalCouponIssuances: savedSummary.totalCouponSent || 0,
          totalCouponRecipients: savedSummary.couponIssued || 0,
          hasCertificateHolder: certHolder.couponIssuances > 0,
          hasNonCertificate: nonCert.couponIssuances > 0,
          certificateHolder: certHolder,
          nonCertificate: nonCert
        };
      }

      // 2순위: 기존 couponSegmentAnalysis (fallback)
      const analysis = props.summary?.couponSegmentAnalysis;
      console.log('🔍 [couponAnalysisData] couponSegmentAnalysis 데이터 사용:', analysis);

      if (!analysis) {
        return {
          totalCouponIssuances: 0,
          totalCouponRecipients: 0,
          hasCertificateHolder: false,
          hasNonCertificate: false,
          certificateHolder: { couponIssuances: 0, couponRecipients: 0, secondary: [] },
          nonCertificate: { couponIssuances: 0, couponRecipients: 0, secondary: [] }
        };
      }

      const processCouponSegment = (primarySegmentData) => {
        if (!primarySegmentData) return { couponIssuances: 0, couponRecipients: 0, secondary: [] };

        // total 데이터 추출
        const total = primarySegmentData.total || {};

        // bySecondarySegment는 배열
        const secondary = [];
        if (primarySegmentData.bySecondarySegment && Array.isArray(primarySegmentData.bySecondarySegment)) {
          primarySegmentData.bySecondarySegment.forEach(item => {
            if (item.couponIssuances > 0) {
              secondary.push({
                label: getSecondarySegmentLabel(item.secondarySegment),
                couponIssuances: item.couponIssuances || 0,
                couponRecipients: item.couponRecipients || 0
              });
            }
          });
        }

        return {
          couponIssuances: total.couponIssuances || 0,
          couponRecipients: total.couponRecipients || 0,
          secondary
        };
      };

      const certificateHolder = processCouponSegment(analysis.byPrimarySegment?.CERTIFICATE_HOLDER);
      const nonCertificate = processCouponSegment(analysis.byPrimarySegment?.NON_CERTIFICATE);

      return {
        totalCouponIssuances: analysis.overall?.couponIssuances || 0,
        totalCouponRecipients: analysis.overall?.couponRecipients || 0,
        hasCertificateHolder: certificateHolder.couponIssuances > 0,
        hasNonCertificate: nonCertificate.couponIssuances > 0,
        certificateHolder,
        nonCertificate
      };
    });

    // 날짜 포맷팅 함수
    const formatDate = (dateInput) => {
      if (!dateInput) return '';

      // dateInput이 문자열이면 그대로 사용, 객체이면 date 속성 추출
      let dateString = dateInput;
      if (typeof dateInput === 'object' && dateInput.date) {
        dateString = dateInput.date;
      }

      const date = new Date(dateString);
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${month}/${day}`;
    };

    // ZEISS 컬러 팔레트
    const COLORS = {
      zeissBlue: '#005EB8',
      certificate: '#005EB8',
      friend: '#008C73',
      review: '#8A5FFB',
      success: '#52c41a',
      warning: '#faad14',
      error: '#f5222d',
      info: '#1890ff',
    };

    // Certificate 차트 생성
    const createCertificateChart = () => {
      if (!trendChartCertificate.value) return;

      if (chartInstances.certificate) {
        try {
          chartInstances.certificate.destroy();
        } catch (e) {
          console.warn('Failed to destroy certificate chart:', e);
        }
        chartInstances.certificate = null;
      }

      const sortedData = [...props.dailyMessageConversions]
        .filter(item => item.messageType === 'certificate')
        .sort((a, b) => new Date(a.date) - new Date(b.date));

      // 데이터가 없으면 차트를 생성하지 않음
      if (sortedData.length === 0) return;

      const labels = sortedData.map(item => {
        const date = new Date(item.date);
        return `${date.getMonth() + 1}/${date.getDate()}`;
      });

      const ctx = trendChartCertificate.value.getContext('2d');
      chartInstances.certificate = new Chart(ctx, {
        type: 'bar',
        data: {
          labels,
          datasets: [
            {
              label: '발송',
              data: sortedData.map(d => d.sent || 0),
              backgroundColor: COLORS.zeissBlue,
              borderRadius: 6,
              yAxisID: 'y'
            },
            {
              label: '클릭',
              data: sortedData.map(d => d.clicks || 0),
              backgroundColor: COLORS.info,
              borderRadius: 6,
              yAxisID: 'y'
            },
            {
              label: '후기작성',
              data: sortedData.map(d => d.reviewSubmissions || 0),
              backgroundColor: COLORS.success,
              borderRadius: 6,
              yAxisID: 'y'
            },
            {
              label: '공유',
              data: sortedData.map(d => d.shares || 0),
              backgroundColor: COLORS.warning,
              borderRadius: 6,
              yAxisID: 'y'
            },
            {
              label: '클릭률 (%)',
              data: sortedData.map(d => d.clickRate || 0),
              type: 'line',
              borderColor: COLORS.info,
              backgroundColor: 'transparent',
              borderWidth: 2,
              yAxisID: 'y1',
              pointBackgroundColor: function(context) {
                if (!context.parsed || context.parsed.y === undefined) return COLORS.info;
                const value = context.parsed.y;
                return value > 100 ? COLORS.error : COLORS.info;
              },
              pointRadius: function(context) {
                if (!context.parsed || context.parsed.y === undefined) return 4;
                const value = context.parsed.y;
                return value > 100 ? 6 : 4;
              },
              pointBorderWidth: 2,
              pointBorderColor: '#fff'
            },
            {
              label: '후기작성률 (%)',
              data: sortedData.map(d => d.reviewSubmissionRate || 0),
              type: 'line',
              borderColor: COLORS.success,
              backgroundColor: 'transparent',
              borderWidth: 2,
              yAxisID: 'y1',
              pointBackgroundColor: function(context) {
                if (!context.parsed || context.parsed.y === undefined) return COLORS.success;
                const value = context.parsed.y;
                return value > 100 ? COLORS.error : COLORS.success;
              },
              pointRadius: function(context) {
                if (!context.parsed || context.parsed.y === undefined) return 4;
                const value = context.parsed.y;
                return value > 100 ? 6 : 4;
              },
              pointBorderWidth: 2,
              pointBorderColor: '#fff'
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: true,
          interaction: {
            mode: 'index',
            intersect: false,
          },
          plugins: {
            legend: {
              position: 'top',
            },
            tooltip: {
              callbacks: {
                label: function(context) {
                  const value = context.parsed.y;
                  if (context.datasetIndex >= 4) {
                    return `${context.dataset.label}: ${value.toFixed(2)}%`;
                  }
                  return `${context.dataset.label}: ${formatNumber(value)}`;
                },
                afterLabel: function(context) {
                  if (context.datasetIndex >= 4 && context.parsed.y > 100) {
                    return '⚠️ 분모작음';
                  }
                  return '';
                }
              }
            }
          },
          scales: {
            y: {
              type: 'linear',
              position: 'left',
              title: { display: true, text: '건수' },
              beginAtZero: true,
              ticks: {
                callback: function(value) {
                  return formatNumber(value);
                }
              }
            },
            y1: {
              type: 'linear',
              position: 'right',
              title: { display: true, text: '비율 (%)' },
              grid: { drawOnChartArea: false },
              beginAtZero: true
            }
          }
        }
      });
    };

    // Friend 차트 생성
    const createFriendChart = () => {
      if (!trendChartFriend.value) return;

      if (chartInstances.friend) {
        try {
          chartInstances.friend.destroy();
        } catch (e) {
          console.warn('Failed to destroy friend chart:', e);
        }
        chartInstances.friend = null;
      }

      const sortedData = [...props.dailyMessageConversions]
        .filter(item => item.messageType === 'friend')
        .sort((a, b) => new Date(a.date) - new Date(b.date));

      // 데이터가 없으면 차트를 생성하지 않음
      if (sortedData.length === 0) return;

      const labels = sortedData.map(item => {
        const date = new Date(item.date);
        return `${date.getMonth() + 1}/${date.getDate()}`;
      });

      const ctx = trendChartFriend.value.getContext('2d');
      chartInstances.friend = new Chart(ctx, {
        type: 'bar',
        data: {
          labels,
          datasets: [
            {
              label: '퀴즈 참여',
              data: sortedData.map(d => d.quizParticipants || 0),
              backgroundColor: COLORS.friend,
              borderRadius: 6,
              yAxisID: 'y'
            },
            {
              label: '예약',
              data: sortedData.map(d => d.reservations || 0),
              backgroundColor: COLORS.error,
              borderRadius: 6,
              yAxisID: 'y'
            },
            {
              label: '공유',
              data: sortedData.map(d => d.shares || 0),
              backgroundColor: COLORS.warning,
              borderRadius: 6,
              yAxisID: 'y'
            },
            {
              label: '퀴즈→예약율 (%)',
              data: sortedData.map(d => {
                if (d.quizParticipants > 0) {
                  return ((d.reservations || 0) / d.quizParticipants * 100);
                }
                return 0;
              }),
              type: 'line',
              borderColor: COLORS.error,
              backgroundColor: 'transparent',
              borderWidth: 2,
              yAxisID: 'y1',
              pointBackgroundColor: function(context) {
                if (!context.parsed || context.parsed.y === undefined) return COLORS.friend;
                const value = context.parsed.y;
                return value > 100 ? COLORS.error : COLORS.friend;
              },
              pointRadius: function(context) {
                if (!context.parsed || context.parsed.y === undefined) return 4;
                const value = context.parsed.y;
                return value > 100 ? 6 : 4;
              },
              pointBorderWidth: 2,
              pointBorderColor: '#fff'
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: true,
          interaction: {
            mode: 'index',
            intersect: false,
          },
          plugins: {
            legend: {
              position: 'top',
            },
            tooltip: {
              callbacks: {
                label: function(context) {
                  const value = context.parsed.y;
                  if (context.datasetIndex >= 3) {
                    return `${context.dataset.label}: ${value.toFixed(2)}%`;
                  }
                  return `${context.dataset.label}: ${formatNumber(value)}`;
                },
                afterLabel: function(context) {
                  if (context.datasetIndex >= 3 && context.parsed.y > 100) {
                    return '⚠️ 분모작음';
                  }
                  return '';
                }
              }
            }
          },
          scales: {
            y: {
              type: 'linear',
              position: 'left',
              title: { display: true, text: '건수' },
              beginAtZero: true,
              ticks: {
                callback: function(value) {
                  return formatNumber(value);
                }
              }
            },
            y1: {
              type: 'linear',
              position: 'right',
              title: { display: true, text: '비율 (%)' },
              grid: { drawOnChartArea: false },
              beginAtZero: true
            }
          }
        }
      });
    };

    // 모든 차트 정리
    const destroyAllCharts = () => {
      if (chartInstances.certificate) {
        try {
          chartInstances.certificate.destroy();
        } catch (e) {
          console.warn('Failed to destroy certificate chart:', e);
        }
        chartInstances.certificate = null;
      }
      if (chartInstances.friend) {
        try {
          chartInstances.friend.destroy();
        } catch (e) {
          console.warn('Failed to destroy friend chart:', e);
        }
        chartInstances.friend = null;
      }
    };

    // 모든 차트 생성
    const createAllCharts = () => {
      nextTick(() => {
        createCertificateChart();
        createFriendChart();
      });
    };

    // 데이터 변경 시 차트 업데이트
    watch(() => props.dailyMessageConversions, () => {
      createAllCharts();
    }, { deep: true });

    // 탭 변경 감지 (필요 시 차트 재생성)
    watch(trendTab, (newTab) => {
      nextTick(() => {
        if (newTab === 'certificate') createCertificateChart();
        else if (newTab === 'friend') createFriendChart();
      });
    });

    onMounted(() => {
      console.log('🔍 [onMounted] OverviewSummary 마운트됨, props.reportId:', props.reportId);
      createAllCharts();
      loadAdjustments();
    });

    // reportId 변경 감지
    watch(() => props.reportId, (newReportId, oldReportId) => {
      console.log('🔍 [watch reportId] 변경 감지:', { oldReportId, newReportId });
      if (newReportId) {
        console.log('🔍 [watch reportId] 보정치 다시 로드 시작');
        // 기존 보정치 초기화 후 새로 로드
        Object.keys(adjustments).forEach(key => delete adjustments[key]);
        loadAdjustments();
      }
    });

    onBeforeUnmount(() => {
      destroyAllCharts();
    });

    return {
      trendTab,
      trendChartCertificate,
      trendChartFriend,
      kpiData,
      funnelSteps,
      certificateSegment,
      nonCertificateSegment,
      cumulativeColumns,
      cumulativeTableData,
      getCumulativeRowClassName,
      reservationSummary,
      dailyReservations,
      hospitalReservations,
      reviewSummary,
      reviewsByCategory,
      reviewsByHospital,
      shareAnalysisData,
      couponAnalysisData,
      formatNumber,
      formatPercentage,
      formatDate,
      getAdjustedValue,
    };
  },
};
</script>

<style scoped>
.overview-summary {
  padding: 24px;
  background: #fafafa;
}

/* KPI 카드 섹션 */
.kpi-section {
  margin-bottom: 24px;
}

.kpi-card {
  border-radius: 12px;
  border: 1px solid #e8e8e8;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background: linear-gradient(135deg, #ffffff 0%, #fafafa 100%);
  height: 100%;
  min-height: 150px;
  position: relative;
  overflow: hidden;
}

.kpi-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(0, 94, 184, 0.03) 0%, transparent 100%);
  opacity: 0;
  transition: opacity 0.3s ease;
}

:deep(.kpi-card .ant-card-body) {
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
  z-index: 1;
}

.kpi-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 94, 184, 0.12);
  border-color: #005EB8;
}

.kpi-card:hover::before {
  opacity: 1;
}

.kpi-subtitle {
  margin-top: 12px;
  font-size: 13px;
  color: #8c8c8c;
  font-weight: 500;
}

.kpi-rate {
  font-size: 15px;
  color: #595959;
  margin-left: 6px;
  font-weight: 500;
}

/* 총 참여자 카드 전용 스타일 */
.kpi-card-participants {
  min-height: 320px;
}

.participants-breakdown {
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px solid #f0f0f0;
}

/* 후기 작성 카드 전용 스타일 */
.kpi-card-reviews {
  min-height: 320px;
}

.reviews-breakdown {
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px solid #f0f0f0;
}

/* 공유 카드 전용 스타일 */
.kpi-card-shares {
  min-height: 320px;
}

.shares-breakdown {
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px solid #f0f0f0;
}

/* 쿠폰 카드 전용 스타일 */
.kpi-card-coupons {
  min-height: 320px;
}

.coupons-breakdown {
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px solid #f0f0f0;
}

.breakdown-section {
  margin-bottom: 12px;
  padding: 8px 0;
}

.breakdown-section:last-child {
  margin-bottom: 0;
}

.breakdown-title {
  font-size: 12px;
  font-weight: 600;
  color: #595959;
  margin-bottom: 4px;
}

.breakdown-value-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 6px;
}

.breakdown-value {
  font-size: 16px;
  font-weight: 700;
  color: #1890ff;
}

.breakdown-inline-desc {
  font-size: 11px;
  color: #a0a0a0;
  font-style: italic;
  line-height: 1.3;
}

.breakdown-items {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.breakdown-item {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  font-size: 11px;
  color: #8c8c8c;
  margin-bottom: 4px;
}

.item-label {
  font-weight: 500;
  flex-shrink: 0;
}

.item-label strong {
  font-weight: 700;
}

.item-value {
  font-weight: 600;
  color: #595959;
  flex-shrink: 0;
}

.item-inline-desc {
  font-size: 10px;
  color: #a0a0a0;
  font-style: italic;
  line-height: 1.3;
}

.breakdown-desc {
  font-size: 11px;
  color: #8c8c8c;
  font-style: italic;
  margin-top: 4px;
}

:deep(.kpi-card .ant-statistic-title) {
  font-size: 14px;
  font-weight: 600;
  color: #595959;
  margin-bottom: 12px;
}

:deep(.kpi-card .ant-statistic-content-prefix) {
  font-size: 20px;
  margin-right: 12px;
}

/* 퍼널 + 세그먼트 섹션 */
.funnel-segment-section {
  margin-bottom: 24px;
}

/* 콤팩트 퍼널 차트 */
.funnel-card-compact {
  height: 100%;
  border-radius: 12px;
  border: 1px solid #e8e8e8;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}

.funnel-container-compact {
  padding: 16px 12px;
}

.funnel-step-compact {
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  padding: 12px 14px;
  border-radius: 8px;
  border: 1px solid #e8e8e8;
  margin-bottom: 10px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

.funnel-step-compact::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(0, 94, 184, 0.05) 0%, rgba(0, 94, 184, 0.02) 100%);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.funnel-step-compact:hover {
  transform: translateY(-4px);
  background: linear-gradient(135deg, #ffffff 0%, #f0f5ff 100%);
  border-color: #005EB8;
  box-shadow: 0 8px 24px rgba(0, 94, 184, 0.15);
}

.funnel-step-compact:hover::before {
  opacity: 1;
}

.step-header-compact {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
  position: relative;
  z-index: 1;
}

.step-number-compact {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 700;
  font-size: 12px;
  flex-shrink: 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
  transition: transform 0.3s ease;
}

.funnel-step-compact:hover .step-number-compact {
  transform: scale(1.1);
}

.step-label-compact {
  font-size: 13px;
  font-weight: 600;
  color: #262626;
  flex: 1;
  transition: color 0.3s ease;
}

.funnel-step-compact:hover .step-label-compact {
  color: #005EB8;
}

.step-metrics-compact {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 8px;
  padding: 0 4px;
  position: relative;
  z-index: 1;
}

.step-value-compact {
  font-size: 18px;
  font-weight: 700;
  color: #262626;
}

.step-rate-compact {
  font-size: 12px;
  font-weight: 600;
  color: #1890ff;
  background: #e6f7ff;
  padding: 2px 8px;
  border-radius: 4px;
}

:deep(.funnel-step-compact .ant-progress) {
  position: relative;
  z-index: 1;
}

.funnel-arrow-compact {
  text-align: center;
  margin: 6px 0;
  color: #bfbfbf;
  transition: all 0.3s ease;
  position: relative;
  z-index: 1;
}

.funnel-step-compact:hover + .funnel-arrow-compact {
  color: #005EB8;
  transform: translateY(2px);
}

.segment-card {
  height: 100%;
  border-radius: 12px;
  border: 1px solid #e8e8e8;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

.segment-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(0, 94, 184, 0.02) 0%, transparent 100%);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.segment-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 94, 184, 0.1);
  border-color: #005EB8;
}

.segment-card:hover::before {
  opacity: 1;
}

:deep(.segment-card .ant-card-head) {
  background: linear-gradient(to bottom, #fafafa, #fff);
  border-bottom: 1px solid #e8e8e8;
}

:deep(.segment-card .ant-card-body) {
  padding: 20px;
}

.segment-stats {
  margin-bottom: 16px;
}

.segment-goal {
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
  font-size: 13px;
  color: #8c8c8c;
  font-weight: 500;
}

/* 트렌드 섹션 */
.trend-section {
  margin-bottom: 24px;
  border-radius: 12px;
  border: 1px solid #e8e8e8;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}

:deep(.trend-section .ant-card-body) {
  padding: 24px;
}

.trend-tabs {
  margin-top: 16px;
}

:deep(.trend-tabs .ant-tabs-tab) {
  font-weight: 500;
  font-size: 14px;
}

:deep(.trend-tabs .ant-tabs-tab-active) {
  font-weight: 600;
}

:deep(.trend-tabs .ant-tabs-content) {
  padding-top: 16px;
}

/* 누적요약 섹션 */
.cumulative-section {
  margin-bottom: 24px;
  border-radius: 12px;
  border: 1px solid #e8e8e8;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}

:deep(.cumulative-section .ant-card-body) {
  padding: 24px;
}

.total-row-text {
  font-weight: 700;
  color: #1890ff;
  font-size: 14px;
}

:deep(.total-row) {
  background: linear-gradient(to right, #f0f5ff, #f5f5f5);
  font-weight: 600;
}

:deep(.total-row td) {
  border-top: 2px solid #1890ff !important;
}

:deep(.ant-card-head-title) {
  font-size: 16px;
  font-weight: 600;
  color: #262626;
}

:deep(.ant-card-head) {
  background: linear-gradient(to bottom, #fafafa, #fff);
  border-bottom: 1px solid #e8e8e8;
  padding: 16px 24px;
}

:deep(.ant-table-thead > tr > th) {
  background: #fafafa;
  font-weight: 600;
  color: #262626;
  font-size: 13px;
}

:deep(.ant-table-tbody > tr:hover > td) {
  background: #f5f9ff;
}

/* 병원 예약 섹션 */
.reservation-section {
  margin: 24px 0;
  padding: 24px;
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e8e8e8;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}

.section-header {
  font-size: 18px;
  font-weight: 700;
  color: #262626;
  margin: 0 0 20px 0;
  padding-bottom: 12px;
  border-bottom: 2px solid #e8e8e8;
}

.reservation-card {
  height: 100%;
  min-height: 450px;
  border-radius: 12px;
  border: 1px solid #e8e8e8;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.reservation-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 94, 184, 0.12);
  border-color: #005EB8;
}

:deep(.reservation-card .ant-card-body) {
  padding: 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.card-title {
  font-size: 15px;
  font-weight: 600;
  color: #262626;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f0f0f0;
}

/* 서머리 카드 */
.summary-stats {
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
}

.stat-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 16px;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  border-radius: 8px;
  border: 1px solid #e8e8e8;
  transition: all 0.3s ease;
}

.stat-item:hover {
  background: linear-gradient(135deg, #ffffff 0%, #f0f5ff 100%);
  border-color: #005EB8;
  transform: scale(1.02);
}

.stat-label {
  font-size: 13px;
  color: #8c8c8c;
  margin-bottom: 8px;
  font-weight: 500;
}

.stat-value {
  font-size: 28px;
  font-weight: 700;
}

.stat-value.total-count {
  color: #1890ff;
}

.stat-value.unique-count {
  color: #52c41a;
}

.stat-value.hospital-count {
  color: #722ed1;
}

.stat-divider {
  height: 1px;
  background: #e8e8e8;
}

/* 일자별 예약 카드 */
.daily-list {
  flex: 1;
}

.daily-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px;
  margin-bottom: 8px;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  border-radius: 6px;
  border: 1px solid #e8e8e8;
  transition: all 0.3s ease;
}

.daily-item:hover {
  background: linear-gradient(135deg, #ffffff 0%, #f0f5ff 100%);
  border-color: #005EB8;
  transform: translateX(4px);
}

.daily-date {
  font-size: 13px;
  font-weight: 600;
  color: #262626;
}

.daily-stats {
  display: flex;
  align-items: center;
  gap: 8px;
}

.daily-count {
  font-size: 14px;
  font-weight: 700;
  color: #1890ff;
}

.daily-users {
  font-size: 12px;
  color: #8c8c8c;
}

/* 병원별 예약 카드 */
.hospital-list {
  flex: 1;
}

.hospital-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px;
  margin-bottom: 8px;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  border-radius: 6px;
  border: 1px solid #e8e8e8;
  transition: all 0.3s ease;
}

.hospital-item:hover {
  background: linear-gradient(135deg, #ffffff 0%, #f0f5ff 100%);
  border-color: #005EB8;
  transform: translateX(4px);
}

.hospital-name {
  font-size: 13px;
  font-weight: 600;
  color: #262626;
  flex: 1;
}

.hospital-count {
  font-size: 14px;
  font-weight: 700;
  color: #52c41a;
  padding: 2px 10px;
  background: #e9fbef;
  border-radius: 4px;
}

/* 빈 메시지 */
.empty-message {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 20px;
  color: #8c8c8c;
  font-size: 13px;
}

/* 리뷰 현황 섹션 */
.review-section {
  margin: 24px 0;
  padding: 24px;
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e8e8e8;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}

.review-card {
  height: 100%;
  min-height: 450px;
  border-radius: 12px;
  border: 1px solid #e8e8e8;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.review-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 94, 184, 0.12);
  border-color: #005EB8;
}

:deep(.review-card .ant-card-body) {
  padding: 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
}

/* 리뷰 서머리 카드 - 병원 예약 카드와 동일한 스타일 사용 */

/* 카테고리별 리뷰 카드 */
.category-list {
  flex: 1;
  max-height: 380px;
  overflow-y: auto;
}

.category-item {
  padding: 10px 12px;
  margin-bottom: 8px;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  border-radius: 6px;
  border: 1px solid #e8e8e8;
  transition: all 0.3s ease;
}

.category-item:hover {
  background: linear-gradient(135deg, #ffffff 0%, #f0f5ff 100%);
  border-color: #005EB8;
  transform: translateX(4px);
}

.category-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}

.category-name {
  font-size: 13px;
  font-weight: 600;
  color: #262626;
  flex: 1;
}

.category-percentage {
  font-size: 11px;
  color: #8c8c8c;
  background: #f0f0f0;
  padding: 2px 8px;
  border-radius: 4px;
}

.category-stats {
  display: flex;
  align-items: center;
  gap: 12px;
}

.category-count {
  font-size: 14px;
  font-weight: 700;
  color: #1890ff;
}

.category-score {
  font-size: 12px;
  font-weight: 600;
  color: #faad14;
}

/* 병원별 리뷰 카드 */
.hospital-review-list {
  flex: 1;
  max-height: 380px;
  overflow-y: auto;
}

.hospital-review-item {
  padding: 10px 12px;
  margin-bottom: 8px;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  border-radius: 6px;
  border: 1px solid #e8e8e8;
  transition: all 0.3s ease;
}

.hospital-review-item:hover {
  background: linear-gradient(135deg, #ffffff 0%, #f0f5ff 100%);
  border-color: #005EB8;
  transform: translateX(4px);
}

.hospital-review-info {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 6px;
}

.hospital-review-rank {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #1890ff, #40a9ff);
  color: white;
  font-size: 11px;
  font-weight: 700;
  border-radius: 50%;
  flex-shrink: 0;
}

.hospital-review-name {
  font-size: 13px;
  font-weight: 600;
  color: #262626;
  flex: 1;
}

.hospital-review-stats {
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: flex-end;
}

.hospital-review-count {
  font-size: 14px;
  font-weight: 700;
  color: #52c41a;
}

.hospital-review-score {
  font-size: 12px;
  font-weight: 600;
  color: #faad14;
  padding: 2px 8px;
  background: #fff7e6;
  border-radius: 4px;
}

/* 평균 점수 stat-value 스타일 */
.stat-value.average-score {
  color: #faad14;
}

/* 긍정 리뷰 비율 stat-value 스타일 */
.stat-value.positive-rate {
  color: #52c41a;
}
</style>
